import React, { forwardRef, useState } from "react";
// import "./FindMember.css";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import FMSelectMultipleOptionItems from "./FMSelectMultipleOptionItems";
import { changeCreateMemberSection } from "../../store/screenSlice";
import { useDispatch, useSelector } from "react-redux";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { screenConfig } from "../../config/screenConfig";
import { updateMember_Sections } from "../../store/memberApiSlice";
import { updateSearchBody } from "../../store/searchMemberApiSlice";
import { updateSearchParamFlags } from "../../store/hasSearchParamFlags";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";

interface Section {
  [key: string]: any;
}

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  Status: boolean;
}

interface ISelectedSections {
  Id: number | null;
  SectionName: string | null;
  MemberId: number | null;
}

interface IProps {
  Sections: Section[];
}

const FMSections: React.FC<IProps> = (props) => {
  const Sections = props.Sections;
  console.log("Sections : ", Sections);
  const dispatch = useDispatch();
  const [SelectedInSections, setSelectedInSections] = useState<number[]>([]);
  const [SelectedNotInSections, setSelectedNotInSections] = useState<number[]>(
    []
  );
  const [SelectedInArrayInSections, setSelectedInArrayInSections] = useState<string[]>([]);
  const [SelectedNotArrayInSections, setSelectedNotArrayInSections] = useState<string[]>([]);

  const searchParameters = useAppSelector((state) => state.searchMemberApiSlice);
  let selectedItems2: number[];

  const onSubmit = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    dispatch(changeCreateMemberSection(screenConfig.memberTags));
  };

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    inFlag: boolean
  ) => {
    console.log("checked..", event.target.value, "-", inFlag);
    let inSections: number[] = [];
    let notInSections: number[] = [];
    let inSectionArray : string [] = [];
    let notInArray : string [] = [];
    inSectionArray.push (...SelectedInArrayInSections)
    inSections.push(...SelectedInSections);
    notInSections.push(...SelectedNotInSections);
    notInArray.push(...SelectedNotArrayInSections);
    if (inFlag === true) {
      //add in list in
      setSelectedInArrayInSections((selectedItems) => [
        ...SelectedInArrayInSections,
        event.target.name,
      ]);
      inSectionArray.push(event.target.name);
      // remove from not in list
      console.log("un checked");
      setSelectedNotArrayInSections((selectedItems) =>
      SelectedNotArrayInSections.filter((item) => {
          return item !== event.target.name;
        })
      );
      //add in list in
      setSelectedInSections((selectedItems) => [
        ...SelectedInSections,
        Number(event.target.id),
      ]);
      inSections.push(Number(event.target.id));
      // remove from not in list
      console.log("un checked");
      setSelectedNotInSections((selectedItems) =>
        SelectedNotInSections.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      //not
      notInArray = notInArray .filter(function (item) {
        return item !== event.target.name;
      });
      //not
      notInSections = notInSections.filter(function (item) {
        return item !== Number(event.target.id);
      });

      // Auto-set "Last Paid Date (AFTER)" to the most recent July 1st (fiscal year start)
      if (!searchParameters.FromLastPaidDate) {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1; // getMonth() is 0-indexed
        // If we're in Jan-June, use previous year's July 1st; otherwise use current year's
        const fiscalYear = currentMonth < 7 ? currentYear - 1 : currentYear;
        const fiscalYearStart = `${fiscalYear}-07-01`;
        dispatch(updateSearchBody({ key: "FromLastPaidDate", value: fiscalYearStart }));
        dispatch(updateSearchParamFlags({ key: "HasOtherSearchParam", value: true }));
        console.log("Auto-set Last Paid Date (AFTER) to:", fiscalYearStart);
      }

      dispatch(
        updateSearchParamFlags({
          key: "HasInSectionsSearchParam",
          value: true,
        })
      );
    } else {
      // add in not in list
      setSelectedNotArrayInSections ((selectedItems) => [
        ...SelectedNotArrayInSections,
        event.target.name
      ]);
      notInArray.push(event.target.name);

      //add in not in list
      setSelectedNotInSections((selectedItems) => [
        ...SelectedNotInSections,
        Number(event.target.id),
      ]);
      notInSections.push(Number(event.target.id));

      //remove from in list
      setSelectedInArrayInSections((selectedItems) =>
      SelectedInArrayInSections.filter((item) => {
          return item !== event.target.name;
        })
      );
      inSectionArray = inSectionArray.filter(function (item) {
        return item !== event.target.name;
      });
      // remove from in list
      console.log("un checked");
      setSelectedInSections((selectedItems) =>
        SelectedInSections.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      inSections = inSections.filter(function (item) {
        return item !== Number(event.target.id);
      });
      dispatch(
        updateSearchParamFlags({
          key: "HasNotInSectionsSearchParam",
          value: true,
        })
      );
    }
    console.log("selectedInItems : ", SelectedInSections);
    console.log("tempInSections : ", inSections);
    console.log("selectedNotInItems : ", SelectedNotInSections);
    console.log("tempNotInSections : ", notInSections);
    dispatch(updateSearchBody({ key: "Sections", value: inSections }));
     dispatch(updateSearchBody({ key: "SectionIn", value: inSectionArray }));
    dispatch (updateSearchBody({ key: "SectionNotIn", value: notInArray }));
    dispatch(
      updateSearchBody({ key: "ExcludedSections", value: notInSections })
    );
  };

  return (
    <>
      <div className="section-box">
        <h3 className="section-heading">Sections</h3>
        <div>
          {typeof Sections != "undefined" ? (
            <FMSelectMultipleOptionItems
              labels={Sections}
              isSection={true}
              onChangeFunction={(
                event: React.ChangeEvent<HTMLInputElement>,
                inFlag: boolean
              ) => handleChange(event, inFlag)}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default FMSections;
